window.EasyContacts ||= {};

window.EasyContacts.initEasyContactsForm = async (projectId?: string) => {
  const { initEasyContactsForm } = await import("../src/easy_contacts/index");
  window.EasyContacts.initEasyContactsForm = initEasyContactsForm;
  initEasyContactsForm(projectId);
};
